module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/add-subscription/add-subscription.component.scss
// module id = ./src/app/admin/add-subscription/add-subscription.component.scss
// module chunks = main